import { Auth, AuthJSON, isAuthJSON } from './auth';
import { Customer, CustomerDto, customerToDto, dtoToCustomer } from './customer';

// #region interfaces

export interface User {
    auth: Auth;
    customer: Customer;
}

export interface UserJSON {
    auth: AuthJSON;
    customer: Customer;
}

export const isUserJSON = (x: unknown): x is UserJSON =>
    typeof x === 'object' &&
    x !== null &&
    'auth' in x &&
    isAuthJSON(x.auth) &&
    'customer' in x &&
    typeof x.customer === 'object';

export interface UserDto {
    readonly Id: number;
    AccessToken: string;
    TokenExpirationDate: string;
    Customer: CustomerDto;
    MustChangePassword?: boolean;
}

// #endregion

// #region mappers

export function dtoToUser(dto: UserDto): User {
    return {
        auth: {
            id: dto.Id,
            accessToken: dto.AccessToken,
            tokenExpires: new Date(dto.TokenExpirationDate),
            mustChangePassword: !!dto.MustChangePassword,
        },
        customer: dtoToCustomer(dto.Customer),
    };
}

export function userToDto(user: User): UserDto {
    return {
        Id: user.auth.id,
        AccessToken: user.auth.accessToken,
        TokenExpirationDate: user.auth.tokenExpires.toISOString(),
        MustChangePassword: user.auth.mustChangePassword,
        Customer: customerToDto(user.customer),
    };
}

export function userToJSON(user: User): string {
    return JSON.stringify({ ...user, auth: { ...user.auth, tokenExpires: user.auth.tokenExpires.toISOString() } });
}

export function JSONToUser(userJSON: string): User | undefined {
    const user = JSON.parse(userJSON) as User;
    if (isUserJSON(user)) {
        const { auth, customer } = user;
        return { auth: { ...auth, tokenExpires: new Date(auth.tokenExpires) }, customer };
    }
    return undefined;
}

// #endregion
